<template>
    <div class="card card-home">
        <div class="card-header">
            Value Expiring
            <b-select ref="select" v-model="interval">
                <optgroup>
                    <option v-for="(title, val) in selectOptions" :value="val">{{ title }}</option>
                </optgroup>
            </b-select>
            <a href="/team/inventory/posted">View</a>
        </div>
        <div class="card-body">
            {{ value | money }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        defaultValue: {
            default: 0,
        },
    },
    data() {
        return {
            selectOptions: {
                week: 'This Week',
                month: 'This Month',
                year: 'This Year',
            },
            interval: 'week',
            value: this.defaultValue,
        };
    },
    watch: {
        interval(newVal) {
            this.getValueExpiring(newVal);
        },
    },
    methods: {
        getValueExpiring(interval) {
            const _this = this;
            axios.get(`/api/team/dashboard/value-expiring/${interval}`).then((response) => {
                _this.value = response.data;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.custom-select:focus,
.custom-select {
    max-width: 170px;
    font-family: 'Tungsten Bold', sans-serif;
    background: transparent;
    box-shadow: none;
    color: #119dea;
    border: 0;
    border-bottom: 1px solid #119dea;
    font-size: 24px;
    height: 48px;
    margin: -17px 0 0 5px;
}
</style>
